import { i18nDispatcherHxDashboard } from 'models/i18n';
import {
  ConsumptionDeviceType,
  DeviceRole,
  ProductionDeviceType
} from 'utils/constants';
import { HxPlanningDeviceColumn } from 'views/modules/Dispatcher/HxDashboard/HxPlanning/HxPlanningContent/HxPlanningContentDevice/hxPlanningContentDeviceUtils';
import { HxPlanningContentDeviceHeaderAction } from 'views/modules/Dispatcher/HxDashboard/HxPlanning/HxPlanningContent/HxPlanningContentDevice/HxPlanningContentDeviceHeader/hxPlanningContentDeviceHeaderUtils';

// ==============================|| I18N SK ||============================== //

const skHxDashboard: i18nDispatcherHxDashboard = {
  devicePanel: {
    title: 'Panel zariadení',
    selectDevice: {
      title: 'Vyberte zariadenie',
      [DeviceRole.CONSUMPTION]: 'Spotrebné zariadenia',
      [DeviceRole.PRODUCTION]: 'Produkčné zariadenia',
      [ConsumptionDeviceType.CONS]: 'Spotrebič',
      [ProductionDeviceType.FVE]: 'FVE',
      [ProductionDeviceType.BESS]: 'BESS',
      [ProductionDeviceType.MVE]: 'MVE',
      [ProductionDeviceType.KGJ]: 'KGJ'
    },
    chart: {
      label: {
        x: 'Čas',
        y: 'Energia [MWh]'
      },
      currentPlan: 'Aktuálny plán',
      nomination: 'Nominácia'
    }
  },
  siPanel: {
    title: 'Panel SI',
    chart: {
      yaxisSystemImbalanceLabel: 'SI [MWh]',
      yaxisSubjectImbalanceLabel: 'Odch. subjektu [MWh]',
      predictionSystemImbalanceHXChartPoints: 'SI predikcia',
      energyImbalanceChartPoints: 'Odchýlka subjektu',
      actualSystemImbalanceChartPoints: 'SI skutočná'
    },
    table: {
      headerLabel: 'Perióda',
      groupedColumnsLabel: 'SI cena',
      positiveSystemImbalanceProbability: 'Prsť. SI > 0'
    }
  },
  hxPlanning: {
    header: {
      filterCaptionLabel: 'Filter',
      columns: {
        [HxPlanningDeviceColumn.NOMINATION]: 'Nominácia',
        [HxPlanningDeviceColumn.CURRENT_PLAN]: 'Akt. plán',
        [HxPlanningDeviceColumn.PREDICTION]: 'Predikcia',
        [HxPlanningDeviceColumn.SOC_MWH]: 'SoC/MWh'
      }
    },
    tables: {
      summary: {
        time: 'Čas',
        estimatedSI: {
          title: 'Odhad SI',
          direction: 'Smer',
          expectationSI: 'Prsť. SI > 0',
          isp: 'ISP'
        },
        imbalance: {
          title: 'Odchýlka',
          plan: 'Plán',
          currentPlan: 'Akt. plán',
          paymentForImbalance: 'Platba'
        },
        deliveryPrice: {
          title: 'Suma dodávky',
          nomination: 'Nomin.',
          currentPlan: 'Akt. plán'
        }
      },
      device: {
        actions: {
          [HxPlanningContentDeviceHeaderAction.DIRECT_CONFIRMATION]:
            'Priame potvrdenie',
          [HxPlanningContentDeviceHeaderAction.PROPAGATION]: 'Propagácia',
          [HxPlanningContentDeviceHeaderAction.DIRECT_PROPAGATION]:
            'Priama propagácia',
          [HxPlanningContentDeviceHeaderAction.SET_PREDICTION_TO_PRODUCTION]:
            'Nastaviť predikciu na produkciu'
        },
        header: {
          [HxPlanningDeviceColumn.NOMINATION]: 'Nominácia',
          [HxPlanningDeviceColumn.CURRENT_PLAN]: 'Akt. plán',
          [HxPlanningDeviceColumn.PREDICTION]: 'Predikcia',
          [HxPlanningDeviceColumn.SOC_MWH]: {
            soc: 'SoC',
            mwh: 'MWh'
          }
        }
      }
    }
  }
};

export default skHxDashboard;
